export default function ContactFooter() {
  return (
    <footer className="w-full bg-foreground-950 text-background-50">
      <div className="px-6 md:px-12 pt-24 md:pt-28 pb-12">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-16">
          <div>
            <p className="text-base text-background-50/70 leading-relaxed max-w-xs">
              A professional engineering team focused on designing and developing
              modern digital software solutions for the iOS platform and related
              technologies.
            </p>
            <div className="mt-12 flex items-center gap-4">
              <span className="w-10 h-10 rounded-full border border-background-50/20 flex items-center justify-center">
                <i className="ri-add-line text-background-50/40 text-sm" />
              </span>
              <span className="w-10 h-10 rounded-full border border-background-50/20 flex items-center justify-center">
                <i className="ri-subtract-line text-background-50/40 text-sm" />
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-background-50/30" />
              <span className="w-10 h-10 rounded-full border border-background-50/20 flex items-center justify-center">
                <i className="ri-close-line text-background-50/40 text-sm" />
              </span>
            </div>
          </div>

          <div className="space-y-10">
            <div>
              <p className="text-xs uppercase tracking-[0.15em] text-background-50/40 mb-3">
                Address
              </p>
              <p className="text-sm text-background-50/80 leading-relaxed">
                Duvhoksgatan 2B
                <br />
                Malmo, 21558
                <br />
                Sweden
              </p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.15em] text-background-50/40 mb-3">
                Phone
              </p>
              <p className="text-sm text-background-50/80">
                +46 723460728
              </p>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.15em] text-background-50/40 mb-3">
                Email
              </p>
              <p className="text-sm text-background-50/80">
                contact@tubiconsult.com
              </p>
            </div>
          </div>

          <div className="flex items-start justify-end">
            <div className="w-48 h-48 rounded-2xl bg-foreground-900 flex items-center justify-center overflow-hidden">
              <svg
                className="w-32 h-32 opacity-30"
                viewBox="0 0 120 120"
                xmlns="http://www.w3.org/2000/svg"
                stroke="currentColor"
                fill="none"
                strokeWidth="0.5"
              >
                <circle cx="60" cy="60" r="50" />
                <circle cx="60" cy="60" r="30" />
                <circle cx="60" cy="60" r="10" />
                <line x1="60" y1="10" x2="60" y2="110" />
                <line x1="10" y1="60" x2="110" y2="60" />
                <line x1="25" y1="25" x2="95" y2="95" />
                <line x1="95" y1="25" x2="25" y2="95" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10 mx-6 md:mx-12" />

      <div className="px-6 md:px-12 py-6">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/30">
            &copy; {new Date().getFullYear()} TubiConsult AB. All rights reserved.
          </p>
          <div className="flex items-center gap-8">
            <span className="text-xs text-background-50/30">Sweden</span>
            <span className="text-xs text-background-50/30">Engineering Excellence</span>
            <span className="text-xs text-background-50/30">Since 2020</span>
          </div>
        </div>
      </div>
    </footer>
  );
}